(function () {
  'use strict'

  /**
   * @ngdoc module
   * @name ThismomentModal
   * @module thismoment.modal.core
   *
   * @description
   * Creates a modal using ui-bootstrap's user options that can accept a template
   */

  var MODULE_NAME = 'thismoment.modal.core'
  var templateUrl = require('./tpl/window.html')

  require('angular')
    .module('thismoment.modal.core', [
      require('angular-animate'),
      require('angular-ui-bootstrap/src/modal')
    ])
    .factory('Modal', modalService)

  modalService.$inject = ['$rootScope', '$uibModal']
  function modalService ($rootScope, $uibModal) {
    return function () {
      var Modal = {
        open: function (userOpts, success, cancel, open, render) {
          // Add default options here.
          var options = angular.merge({
            animation: false,
            size: userOpts.resolve.options.size,
            windowTemplateUrl: templateUrl
          }, userOpts)

          return function () {
            var modalInstance = $uibModal.open(options)

            // register the two "exit" callbacks, success & cancel
            modalInstance.result.then(function (data) {
              if (typeof success === 'function') {
                success(data)
              }
            }, function (data) {
              $rootScope.$emit('modalClosed')
              if (typeof cancel === 'function') {
                cancel(data)
              }
            })

            // register the "open" callback, for any functions to execute
            // after the modal has opened
            modalInstance.opened.then(function (data) {
              if (typeof open === 'function') {
                open(data)
              }
            })

            // register the "render" callback, for any functions to execute
            // after the modal has rendered
            modalInstance.rendered.then(function (data) {
              if (typeof render === 'function') {
                render(data)
              }
            })
          }
        }
      }

      return Modal
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/modal/modal.js